<template>
    <div>
        <nav class="mt-12 space-y-2 flex flex-col">
            <div v-if="user" class="mb-8 flex items-center text-white text-left">
                <h4 class="text-sm font-medium text-base !text-white flex-grow dark:text-white ">
                    Olá, {{ user.first_name }}!
                </h4>


            </div>

            <SidebarItem
                :href="route('craftable-pro.leads.index')"
                :icon="ArrowTrendingUpIcon"
                v-can="'craftable-pro.leads.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                Leads
            </SidebarItem>

            <SidebarItem
                :href="route('craftable-pro.clients.index')"
                :icon="UserGroupIcon"
                v-can="'craftable-pro.client.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                Clientes
            </SidebarItem>

            <SidebarItem
                    :href="route('craftable-pro.nps-client-forms.index')"
                    :icon="ChartBarIcon"
                    v-can="'craftable-pro.nps-client-forms.index'"
                    class="text-white"
                    :icon-view="isCollapsed"
                >
                    NPS
                </SidebarItem>


            <SidebarItem
                :href="route('craftable-pro.trainings.index')"
                :icon="AcademicCapIcon"
                v-can="'craftable-pro.trainings.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                Gerenciar Treinamentos
            </SidebarItem>

            <SidebarItem
                :href="route('craftable-pro.discount-coupons.index')"
                :icon="TagIcon"
                v-can="'craftable-pro.discount-coupons.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                Cupons de Desconto
            </SidebarItem>

            <SidebarItem
                :href="route('craftable-pro.craftable-pro-users.index')"
                :icon="UsersIcon"
                v-can="'craftable-pro.craftable-pro-user.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                {{ $t("craftable-pro", "Access") }}
            </SidebarItem>
            <SidebarItem
                :href="route('craftable-pro.roles.index')"
                :icon="KeyIcon"
                v-can="'craftable-pro.role.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                {{ $t("craftable-pro", "Roles") }}
            </SidebarItem>
            <SidebarItem
                :href="route('craftable-pro.translations.index')"
                :icon="LanguageIcon"
                v-can="'craftable-pro.translation.index'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                {{ $t("craftable-pro", "Localization") }}
            </SidebarItem>
            <SidebarItem
                :href="route('craftable-pro.settings.index')"
                :icon="Cog8ToothIcon"
                v-can="'craftable-pro.settings.edit'"
                class="text-white"
                :icon-view="isCollapsed"
            >
                {{ $t("craftable-pro", "Settings") }}
            </SidebarItem>
        </nav>
    </div>
</template>

<script setup lang="ts">
import {
    KeyIcon,
    LanguageIcon,
    UsersIcon,
    Cog8ToothIcon,
    MapIcon,
    BriefcaseIcon,
    LightBulbIcon,
    VideoCameraIcon,
    MagnifyingGlassPlusIcon,
    ListBulletIcon,
    PresentationChartLineIcon,
    HomeIcon,
    DocumentMagnifyingGlassIcon,
    XCircleIcon,
    ArchiveBoxXMarkIcon,
    ArchiveBoxArrowDownIcon,
    UserGroupIcon,
    DocumentDuplicateIcon as DocumentDuplicateIconOutline,
    FolderOpenIcon,
    BellIcon,
    EyeIcon,
    BellAlertIcon,
    EnvelopeIcon,
    ArrowsPointingOutIcon,
    MegaphoneIcon,
    TrophyIcon,
    CircleStackIcon, RectangleGroupIcon, DocumentChartBarIcon, ClockIcon, BanknotesIcon, TagIcon,
    DocumentTextIcon,
    ChatBubbleLeftRightIcon,
    Square3Stack3DIcon, PhotoIcon, ChartBarIcon,
} from "@heroicons/vue/24/outline";
import {
    CalendarDaysIcon,
    DocumentDuplicateIcon,
    IdentificationIcon,
}
    from "@heroicons/vue/24/solid";
import SidebarItem from "./SidebarItem.vue";
import SidebarGroup from "./SidebarGroup.vue"
import {
    AcademicCapIcon,
    ArrowTrendingUpIcon, BuildingOffice2Icon, ClipboardDocumentListIcon,
    DocumentCheckIcon, ExclamationCircleIcon, StarIcon,
    UserIcon
} from "@heroicons/vue/20/solid";
import {computed, onMounted, ref, toRef, toRefs, watch} from "vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ThemeToggle from "@/craftable-pro/Components/Theme/ThemeToggle.vue";

interface Props {
    user?: any;
    isCollapsed: boolean
}

dayjs.extend(customParseFormat);

const props = defineProps<Props>();

const getIcon = (icon: string) => {
    const iconsMap: Record<string, any> = {
        ['AcademicCapIcon']: AcademicCapIcon,
        ['ArrowTrendingUpIcon']: ArrowTrendingUpIcon,
        ['BuildingOffice2Icon']: BuildingOffice2Icon,
        ['ClipboardDocumentListIcon']: ClipboardDocumentListIcon,
        ['DocumentCheckIcon']: DocumentCheckIcon,
        ['DocumentDuplicateIcon']: DocumentDuplicateIcon,
        ['ExclamationCircleIcon']: ExclamationCircleIcon,
        ['HomeIcon']: HomeIcon,
        ['IdentificationIcon']: IdentificationIcon,
        ['LanguageIcon']: LanguageIcon,
        ['LightBulbIcon']: LightBulbIcon,
        ['ListBulletIcon']: ListBulletIcon,
        ['MapIcon']: MapIcon,
        ['PresentationChartLineIcon']: PresentationChartLineIcon,
        ['UserGroupIcon']: UserGroupIcon,
        ['UsersIcon']: UsersIcon,
        ['VideoCameraIcon']: VideoCameraIcon,
        ['Cog8ToothIcon']: Cog8ToothIcon,
        ['BellIcon']: BellIcon,
        ['EyeIcon']: EyeIcon,
        ['FolderOpenIcon']: FolderOpenIcon,
        ['MagnifyingGlassPlusIcon']: MagnifyingGlassPlusIcon,
        ['StarIcon']: StarIcon,
        ['XCircleIcon']: XCircleIcon,
        ['ArchiveBoxArrowDownIcon']: ArchiveBoxArrowDownIcon,
        ['ArchiveBoxXMarkIcon']: ArchiveBoxXMarkIcon,
        ['TagIcon']: TagIcon,
    };

    return iconsMap[icon];
};

onMounted(() => {
});
</script>

<style scoped>

</style>

<style scoped>
@-webkit-keyframes ring {
    0% {
        -webkit-transform: rotateZ(0);
    }
    1% {
        -webkit-transform: rotateZ(30deg);
    }
    3% {
        -webkit-transform: rotateZ(-28deg);
    }
    5% {
        -webkit-transform: rotateZ(34deg);
    }
    7% {
        -webkit-transform: rotateZ(-32deg);
    }
    9% {
        -webkit-transform: rotateZ(30deg);
    }
    11% {
        -webkit-transform: rotateZ(-28deg);
    }
    13% {
        -webkit-transform: rotateZ(26deg);
    }
    15% {
        -webkit-transform: rotateZ(-24deg);
    }
    17% {
        -webkit-transform: rotateZ(22deg);
    }
    19% {
        -webkit-transform: rotateZ(-20deg);
    }
    21% {
        -webkit-transform: rotateZ(18deg);
    }
    23% {
        -webkit-transform: rotateZ(-16deg);
    }
    25% {
        -webkit-transform: rotateZ(14deg);
    }
    27% {
        -webkit-transform: rotateZ(-12deg);
    }
    29% {
        -webkit-transform: rotateZ(10deg);
    }
    31% {
        -webkit-transform: rotateZ(-8deg);
    }
    33% {
        -webkit-transform: rotateZ(6deg);
    }
    35% {
        -webkit-transform: rotateZ(-4deg);
    }
    37% {
        -webkit-transform: rotateZ(2deg);
    }
    39% {
        -webkit-transform: rotateZ(-1deg);
    }
    41% {
        -webkit-transform: rotateZ(1deg);
    }

    43% {
        -webkit-transform: rotateZ(0);
    }
    100% {
        -webkit-transform: rotateZ(0);
    }
}

@-moz-keyframes ring {
    0% {
        -moz-transform: rotate(0);
    }
    1% {
        -moz-transform: rotate(30deg);
    }
    3% {
        -moz-transform: rotate(-28deg);
    }
    5% {
        -moz-transform: rotate(34deg);
    }
    7% {
        -moz-transform: rotate(-32deg);
    }
    9% {
        -moz-transform: rotate(30deg);
    }
    11% {
        -moz-transform: rotate(-28deg);
    }
    13% {
        -moz-transform: rotate(26deg);
    }
    15% {
        -moz-transform: rotate(-24deg);
    }
    17% {
        -moz-transform: rotate(22deg);
    }
    19% {
        -moz-transform: rotate(-20deg);
    }
    21% {
        -moz-transform: rotate(18deg);
    }
    23% {
        -moz-transform: rotate(-16deg);
    }
    25% {
        -moz-transform: rotate(14deg);
    }
    27% {
        -moz-transform: rotate(-12deg);
    }
    29% {
        -moz-transform: rotate(10deg);
    }
    31% {
        -moz-transform: rotate(-8deg);
    }
    33% {
        -moz-transform: rotate(6deg);
    }
    35% {
        -moz-transform: rotate(-4deg);
    }
    37% {
        -moz-transform: rotate(2deg);
    }
    39% {
        -moz-transform: rotate(-1deg);
    }
    41% {
        -moz-transform: rotate(1deg);
    }

    43% {
        -moz-transform: rotate(0);
    }
    100% {
        -moz-transform: rotate(0);
    }
}

@keyframes ring {
    0% {
        transform: rotate(0);
    }
    1% {
        transform: rotate(30deg);
    }
    3% {
        transform: rotate(-28deg);
    }
    5% {
        transform: rotate(34deg);
    }
    7% {
        transform: rotate(-32deg);
    }
    9% {
        transform: rotate(30deg);
    }
    11% {
        transform: rotate(-28deg);
    }
    13% {
        transform: rotate(26deg);
    }
    15% {
        transform: rotate(-24deg);
    }
    17% {
        transform: rotate(22deg);
    }
    19% {
        transform: rotate(-20deg);
    }
    21% {
        transform: rotate(18deg);
    }
    23% {
        transform: rotate(-16deg);
    }
    25% {
        transform: rotate(14deg);
    }
    27% {
        transform: rotate(-12deg);
    }
    29% {
        transform: rotate(10deg);
    }
    31% {
        transform: rotate(-8deg);
    }
    33% {
        transform: rotate(6deg);
    }
    35% {
        transform: rotate(-4deg);
    }
    37% {
        transform: rotate(2deg);
    }
    39% {
        transform: rotate(-1deg);
    }
    41% {
        transform: rotate(1deg);
    }

    43% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(0);
    }
}
</style>

